import { filter, firstValueFrom, timeout } from "rxjs";
import { entityLiveUpdates$, EntityLiveUpdateEvent } from "./events";

const ENTITY_LIVE_UPDATE_TIMEOUT_MS = 65_000;

export const waitForEntityLiveUpdate = (
  type: EntityLiveUpdateEvent["type"],
  timeoutMs = ENTITY_LIVE_UPDATE_TIMEOUT_MS
): Promise<void> =>
  firstValueFrom(
    entityLiveUpdates$.pipe(
      filter((event) => event.type === type),
      timeout(timeoutMs)
    )
  ).then(() => undefined);
